import { useAnalytics } from '@/hooks/use-analytics'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { useEffect, useRef } from 'react'

import { PipelineView } from './-components/pipeline-view'

function PipelinePage() {
  const { capture } = useAnalytics()
  const viewedRef = useRef(false)

  useEffect(() => {
    if (viewedRef.current)
      return
    viewedRef.current = true
    capture('orders_pipeline_viewed', {})
  }, [capture])

  return (
    <div className="flex flex-col gap-6 px-4 py-4 lg:px-6 md:py-6">
      <PipelineView />
    </div>
  )
}

export const Route = createFileRoute('/_authed/_user/orders/pipeline/')({
  beforeLoad: ({ context }) => {
    if (!context.auth.canUseOrderInbox) {
      throw redirect({ to: '/' })
    }
  },
  component: PipelinePage,
})
